<template>
  <div class="select-department">
    <div class="body-wrapper">
      <!--部门选择-->
      <div class="department-wrapper">
        <div ref="breadcrumb" key="breadcrumb" class="breadcrumb">
          <div class="breadcrumb-item" @click="changeBreadcrumb(-1)">
            <div class="text">全部</div>
          </div>
          <div class="breadcrumb-item" v-for="(node, idx) in treePath" :key="node">
            <div style="margin: 0 5px;">&gt;</div>
            <div class="text" @click="changeBreadcrumb(idx)">
              {{ departmentMap[node].name }}
            </div>
          </div>
        </div>
        <div class="scroll-wrapper" v-ps>
          <el-checkbox-group :value="currentDepartmentSelected">
            <div class="checkbox-wrapper" v-for="d in currentDepartments" :key="d.id">
              <el-checkbox :label="d.id" @change="departmentChange($event, [d.id])">
                {{ " " }}
              </el-checkbox>
              <div class="name-wrapper pointer" @click="stepInfoSubDepartment(d)">
                <span>{{ d.name }}</span>
              </div>
              <i
                v-if="!d.fake && _.get(departmentMap[d.id], 'children.length')"
                class="el-icon-arrow-right"
              ></i>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectDepartment",
  props: {
    selected: {
      type: Array,
      default: () => []
    },
    rootDepartment: {
      type: Object,
      default: () => ({})
    },
    departmentMap: {
      type: Object,
      default: () => ({})
    },
    showRawRootDepartmentName: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      width: 300,
      isUserList: true,
      // 部门选择状态下,面包屑导航路径
      treePath: []
    }
  },
  computed: {
    curDepartmentId() {
      return this.treePath.length > 0
        ? this.treePath[this.treePath.length - 1]
        : this.rootDepartment.id
    },
    currentDepartments() {
      // 部门选择状态下,部门列表
      let additionalDepartments = []
      if (this.curDepartmentId === this.rootDepartment.id) {
        additionalDepartments.push({
          id: this.rootDepartment.id,
          name: this.showRawRootDepartmentName ? this.rootDepartment.name : "全公司",
          fake: true
        })
      }
      return additionalDepartments.concat(this.departmentMap[this.curDepartmentId]?.children || [])
    },
    currentDepartmentSelected() {
      return this.currentDepartments
        .filter(department => this.selected.includes(department.id))
        .map(d => d.id)
    }
  },
  methods: {
    initBreadcrumbPosition() {
      // 处理滚动:自动滚动在最右边
      this.$nextTick(() => {
        let breadcrumb = this.$refs.breadcrumb
        breadcrumb.scrollLeft = breadcrumb.scrollWidth - this.width + 24
      })
    },
    stepInfoSubDepartment({ id, fake }) {
      if (this.departmentMap[id]?.children?.length && !fake) {
        this.treePath.push(id)
        this.initBreadcrumbPosition()
      }
    },
    changeBreadcrumb(idx) {
      this.treePath = this.treePath.slice(0, idx + 1)
      this.initBreadcrumbPosition()
    },
    departmentChange(isAdd, ids) {
      this.$emit("change", { isAdd, ids })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-department {
  .switch {
    height: 36px;
    background: #f5f7fa;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .el-icon-arrow-right {
      margin-left: auto;
    }
  }
  .body-wrapper {
    padding: 6px 6px 6px 12px;
    .breadcrumb {
      display: flex;
      overflow: hidden;
      .breadcrumb-item {
        display: flex;
        flex: 0 0 auto;
        .text {
          color: #407fff;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        &:last-of-type {
          .text {
            color: unset;
            cursor: unset;
            &:hover {
              text-decoration: unset;
            }
          }
        }
      }
    }
  }
  .scroll-wrapper {
    max-height: 200px;
    min-height: 50px;
    position: relative;
    .el-checkbox-group {
      display: flex;
      flex-flow: column;
      /*自定义文字显示*/
      .checkbox-wrapper {
        display: flex;
        position: relative;
        align-items: center;
        height: 40px;
        .name-wrapper {
          height: 100%;
          flex: 1;
          font-size: 14px;
          display: flex;
          align-items: center;
        }
        .el-icon-arrow-right {
          font-size: 14px;
          position: absolute;
          right: 0px;
          top: 12px;
        }
        &:hover {
          background-color: #f0f4fd;
        }
      }
      .el-checkbox {
        display: flex;
        align-items: center;
        margin-right: 0;
        height: 40px;
        &:hover {
          background-color: #f0f4fd;
        }
        ::v-deep .el-checkbox__label {
          display: flex;
          align-items: center;
          .avatar {
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>
